<template>
    <div>
        <vggrid  :random="Math.floor(Math.random() * 999999)" ref="xGrid" :list="pqcitemCrossList" tableheight="600" flexname="" :cols="cols"
                :showfooter="false" :showPage="false" :resizable="true"  :mergeRow='mergeRow'
        >
            <template slot="btn" v-if="isEdit">
                <div class="expqc-topbtn">
                    <div class="expqc-topbtn-title">评审人[{{pexpert.pexpertname}}]的初审过程</div>
                </div>
                <!--<vxe-button class="vxe-btn" @click="save" :loading="btnLoading">保存</vxe-button>-->
            </template>
        </vggrid>
        <div class="split-line"></div>
        <div class="expqc-container">
        <vggrid :list="pqcesList" :random="Math.floor(Math.random() * 999999)" flexname="" :cols="pqcesCols"
                :showfooter="false" :showPage="false" :resizable="true"
        >
            <template slot="btn">
                <div class="expqc-topbtn">
                    <div class="expqc-topbtn-title">评审人[{{pexpert.pexpertname}}]的预审结论</div>
                </div>
            </template>
        </vggrid>
        </div>
    </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  export default {
    name: 'pqcesFormCheckComByEx',
    mixins: [common],
    components: {vggrid},
    props: {
      pexpert: {},
      projectid: {},
      pexpertid: {},
      activeName: {}
    },
    data () {
      return {
        project: {},
        list: [],
        selectList: [],
        pqcitemcheckList: [],
        psuComList: [],
        pqcitemCrossList: [],
        pqcesList: [],
        btnLoading: false,
        model: {},
        isEdit: true,
        mergeRow:['pqcitemchecktypedesc'],
        pqcesCols: [
          {field: 'comfullname', fieldtype: 'C', title: '投标人', calculExpr: '', addNewRowFlg: false, width: 280},
          {field: 'pqcesresultdesc', fieldtype: 'C', title: '检查结果', calculExpr: '', addNewRowFlg: false, width: 100},
          {field: 'pqcescdesc', fieldtype: 'C', title: '检查意见', calculExpr: '', editRender: { name: 'input'}}
        ],
        cols: []
      }
    },
    async created () {
      await this.getModel()
      this.getCols()
      await this.getPqcitemCrossList()
    },
    watch: {
      async pexpertid () {
        this.getCols()
        await this.getPqcitemCrossList()
      }
      // activeName () {
      //   console.log(this.activeName)
      //   if(this.activeName === 'aysdb') {
      //     this.getCols()
      //     this.getPqcitemCrossList()
      //   }
      // }
    },
    methods: {
      // 交叉表的数据
      async getPqcitemCrossList () {
        this.pqcitemCrossList = []
        this.loading = true
        let project = {}
        project.projectisqcheck = this.project.projectisqcheck
        let res = await request({
          method: 'get',
          url: '/expert/getPqcitemCrossByProjectId',
          params: {
            projectid: this.projectid,
            pexpertid: this.pexpertid,
            project:project
          }
        })
        this.pqcitemCrossList = res.pqcitemList
        this.pqcitemcheckList = res.pqcitemcheckList
        this.psuComList = res.psuList
        await this.setCrossCols(res)
        await this.setPqcesList()
        this.loading = false
      },
      // 我的预审结论数据
      async setPqcesList() {
        await this.getPqcesList()
      },
      // 评审人对供应商做检查的过程中，把结果值返回到汇总表
      getPsuPqcesResultDesc (item) {
        // 供应商通过的检查项数
        let pass = this.selectList.filter(v => +v.pqcitemcheckcomid === +item.psucomid && +v.pqcitemcheckresult === 1)
        // 供应商不通过的检查项数
        let faile = this.selectList.filter(v => +v.pqcitemcheckcomid === +item.psucomid &&  +v.pqcitemcheckresult === 2)
        // 供应商的所有检查项
        let selectComList = this.selectList.filter(v => +v.pqcitemcheckcomid === +item.psucomid)
        if (pass.length === selectComList.length && !faile.length) {
          // '通过'
          return '1'
        } else {
          if ((faile.length + pass.length) === selectComList.length) {
            if (faile.length) {
              // '不通过'
              return '2'
            } else {
              return ''
            }
          } else {
            return  ''
          }
        }
      },
      // 获取已检查结果，把结果值说明返回交叉表
      getCrossCheckResultDesc (item) {
        // 供应商通过的检查项数
        let pass = this.pqcitemcheckList.filter(v => +v.pqcitemcheckpqcitemid === +item.pqcitemid && +v.pqcitemcheckcomid === +item.psucomid && +v.pqcitemcheckresult === 1)
        // 供应商不通过的检查项数
        let faile = this.pqcitemcheckList.filter(v => +v.pqcitemcheckpqcitemid === +item.pqcitemid &&  +v.pqcitemcheckcomid === +item.psucomid &&  +v.pqcitemcheckresult === 2)
        // 供应商的所有检查项
        let selectComList = this.pqcitemcheckList.filter(v => +v.pqcitemcheckpqcitemid === +item.pqcitemid &&  +v.pqcitemcheckcomid === +item.psucomid)
        if (pass.length === selectComList.length && !faile.length) {
          // '通过 1'
          return '通过'
        } else {
          if ((faile.length + pass.length) === selectComList.length) {
            if (faile.length) {
              // '不通过 2'
              return '不通过'
            } else {
              return ''
            }
          } else {
            return  ''
          }
        }
      },
      // 设置交叉表的表头
      async setCrossCols (res) {
        if (res.psuList.length) {
          for(let i=0;i<res.psuList.length;i++) {
            let item = res.psuList[i]
            this.cols.push({
              title:item.comfullname,
              children: [
                {
                  // title: item.appendfilename,
                  slots: {
                    default: 'default',
                    default: ({row}) => {
                      return this.getCrossCheckResultDesc({pqcitemid: row.pqcitemid, psucomid: item.comid})
                    },
                    header: ({ column }) => {
                      return [
                        <span onClick={this.fileClick.bind(this,column,item)} style="color: #409EFF;padding-left:10px">{item.appendfilename}</span>
                    ]
                    }
                  }
                }
              ],
              showOverflow: true
            })
          }
        }
      },
      getCols () {
        this.cols = [
          {field: 'pqcitemchecktypedesc', fieldtype: 'C', title: '初审分类', calculExpr: '', addNewRowFlg: false, width: 100},
          {
            field: 'pqcitemcheckcontent', fieldtype: 'C', title: '初审内容', calculExpr: '', addNewRowFlg: false
          }
          // {field: 'pqcitemcheckdemand', fieldtype: 'C', title: '采购文件要求', calculExpr: '', addNewRowFlg: false}
        ]
      },
      fileClick (col, item) {
        this.downFile(item.appendurl)
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res
      },
      // 结果汇总表的数据
      async getPqcesList () {
        this.pqcesList = await request({
          url: 'expert/getPqcesByProjectId',
          method: "get",
          params: {
            pexpertid: this.pexpertid,
            projectid: this.projectid
          }
        })
        this.pqcesList = this.pqcesList.map(v => {
          if (+v.pqcesresult === 1) {
            v.checked_1 = true
          }
          if (+v.pqcesresult === 2) {
            v.checked_2 = true
          }
          return v
        })
      }
    }
  }
</script>
<style lang="scss">
    .expqc-container {
        margin-top: 20px;
            .expqc-topbtn {
                display: flex;
                align-items: center;
                .expqc-topbtn-title {
                    padding-left: 10px;
                    text-align: center;
                }
                .expqc-topbtn-btn {
                    padding-left: 20px;
                }
            }
    }
    .expqc-footbtn {
        text-align: right;
        padding-top: 10px;
    }
</style>